import { IResourceComponentsProps } from "@pankod/refine-core";
import {
  Create,
  useForm,
} from "@pankod/refine-antd";
import { IContents } from "interfaces";
import { ContentsForm } from "components/forms";

export const ContentsCreate: React.FC<IResourceComponentsProps> = () => {
  const { formProps, saveButtonProps, queryResult } = useForm<IContents>();
  return (
    <Create saveButtonProps={saveButtonProps}>
      <ContentsForm
        formProps={formProps}
        queryResult={queryResult}
      />
    </Create>
  );
};
